// extracted by mini-css-extract-plugin
export default {"gaugeBg":"Gauge_gaugeBg__1nT1s","gaugeMiddle":"Gauge_gaugeMiddle__eXPYV","gaugeTextBags":"Gauge_gaugeTextBags__4meCa"};